//
// Module for the Manual wizard's Options step
//
rs.module("participant/benefit/setup/manual/wizard/paymentoptionstep",

    ["common/visibility", "pg/numerical-input"],

    function (visibility, numericalInput) {

        // Initialize the module
        function initialize(jsSelectors, codeValues, payOptionMethodDictionary, variablePayOptionKeys) {

            // get JS selectors
            var stepContainer = $.js(jsSelectors.stepContainer);

            var adjustAccountBalanceCheckbox = stepContainer.js(jsSelectors.adjustAccountBalanceCheckbox, { required: false });
            var accountBalanceContainer = stepContainer.js(jsSelectors.accountBalanceContainer, { required: false });

            var lumpSumTaxibilityContainer = stepContainer.js(jsSelectors.lumpSumTaxibilityContainer);

            var backDropTaxableInput = stepContainer.js(jsSelectors.backDropTaxableInput, { required: false });
            var backDropNonTaxableInput = stepContainer.js(jsSelectors.backDropNonTaxableInput, { required: false });
            var backDropTotalInput = stepContainer.js(jsSelectors.backDropTotalInput, { required: false });
            var backDropTotalHidden = stepContainer.js(jsSelectors.backDropTotalHidden, { required: false });

            var payOptionSelect = stepContainer.js(jsSelectors.payOptionSelect);
            var payOptionChildContainer = stepContainer.js(jsSelectors.payOptionChildContainer);
            var payOptionPercentInput = payOptionChildContainer.js(jsSelectors.payOptionPercentInput);
            var payOptionYearsInput = payOptionChildContainer.js(jsSelectors.payOptionYearsInput);
            var payOptionPaymentsInput = payOptionChildContainer.js(jsSelectors.payOptionPaymentsInput);
            var payOptionTerminationDateInput = payOptionChildContainer.js(jsSelectors.payOptionTerminationDateInput);
            var beneficiariesContainer = stepContainer.js(jsSelectors.beneficiariesContainer);

            // Hookup adjustAccountBalanceCheckbox change event
            adjustAccountBalanceCheckbox.change(adjustAccountBalanceChange);

            // backDropTaxableInput + backDropNonTaxableInput = backDropTotalInput
            numericalInput.registerSumInputs(backDropTotalInput, 2, backDropTaxableInput, backDropNonTaxableInput);
            // and also stick the result in the hidden field (as backDropNonTaxableInput is disabled)
            numericalInput.registerSumInputs(backDropTotalHidden, 2, backDropTaxableInput, backDropNonTaxableInput);

            // Hookup payOptionSelect change event
            payOptionSelect.change(payOptionChange);

            // Hookup payOptionYearsInput and payOptionPaymentsInput change events
            payOptionYearsInput.on('input', payOptionYearsChange);
            payOptionPaymentsInput.on('input', payOptionPaymentsChange);

            // On checkbox change, toggle account balanace display
            function adjustAccountBalanceChange() {
                visibility.setVisible(accountBalanceContainer, this.checked);
            }

            // Pay Option change event
            function payOptionChange() {

                // Get selected Pay Option Key
                var selectedPayOptionKey = payOptionSelect.val();

                // Get corresponding selected Pay Option Method
                var selectedPayOptionMethod = payOptionMethodDictionary[selectedPayOptionKey];

                var isJointAndSurvivor =
                    selectedPayOptionMethod == codeValues.contingentJandS ||
                    selectedPayOptionMethod == codeValues.trueJAndS ||
                    selectedPayOptionMethod == codeValues.jAndSPopup;

                // set visibility of pay option container and enabling/disabling of child fields
                if (selectedPayOptionKey && variablePayOptionKeys.includes(selectedPayOptionKey)) {

                    visibility.setVisible(payOptionChildContainer, true);

                    if (isJointAndSurvivor) {

                        payOptionPercentInput.prop("disabled", false);
                        payOptionYearsInput.prop("disabled", true).val("").clearErrors();
                        payOptionPaymentsInput.prop("disabled", true).val("").clearErrors();
                        payOptionTerminationDateInput.prop("disabled", true).val("").clearErrors();

                    } else if (selectedPayOptionMethod == codeValues.certainAndLife) {

                        payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                        payOptionYearsInput.prop("disabled", false);
                        payOptionPaymentsInput.prop("disabled", false);
                        payOptionTerminationDateInput.prop("disabled", true).val("").clearErrors();

                    } else if (selectedPayOptionMethod == codeValues.term) {

                        payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                        payOptionYearsInput.prop("disabled", false);
                        payOptionPaymentsInput.prop("disabled", false);
                        payOptionTerminationDateInput.prop("disabled", false);

                    } else {

                        payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                        payOptionYearsInput.prop("disabled", true).val("").clearErrors();
                        payOptionPaymentsInput.prop("disabled", true).val("").clearErrors();
                        payOptionTerminationDateInput.prop("disabled", true).val("").clearErrors();

                    }

                } else {

                    visibility.setVisible(payOptionChildContainer, false);

                    payOptionPercentInput.prop("disabled", true).val("").clearErrors();
                    payOptionYearsInput.prop("disabled", true).val("").clearErrors();
                    payOptionPaymentsInput.prop("disabled", true).val("").clearErrors();
                    payOptionTerminationDateInput.prop("disabled", true).val("").clearErrors();
                }

                // set visibility of lump sum container
                if (selectedPayOptionKey && selectedPayOptionMethod == codeValues.lumpSum) {
                    visibility.setVisible(lumpSumTaxibilityContainer, true);
                } else {
                    lumpSumTaxibilityContainer.find("input").val("").clearErrors();

                    visibility.setVisible(lumpSumTaxibilityContainer, false);
                }

                // set visibility of beneficiaries container
                visibility.setVisible(beneficiariesContainer, selectedPayOptionKey && selectedPayOptionMethod != codeValues.singleLife);
            }

            // On payOptionYearsInput change
            function payOptionYearsChange() {

                var yearsEntered = payOptionYearsInput.val() !== '';

                // If a value for years is entered, disable and clear the payments input
                payOptionPaymentsInput.prop('disabled', yearsEntered);
                if (yearsEntered) {
                    payOptionPaymentsInput.val("").clearErrors();
                }
            }

            // On payOptionPaymentsInput change
            function payOptionPaymentsChange() {

                var paymentsEntered = payOptionPaymentsInput.val() !== '';

                // If a value for payments is entered, disable and clear the years input
                payOptionYearsInput.prop('disabled', paymentsEntered);
                if (paymentsEntered) {
                    payOptionYearsInput.val("").clearErrors();
                }
            }
        }

        // Exported public API
        var exports = {
            initialize: initialize
        };

        return exports;
    }
);